import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/services/user.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (this.userService.currentUserValue) {
      this.userService.logout();
    } else {
      this.router.navigateByUrl('/login');
    }
  }

}
